
import InputNumber from 'primevue/inputnumber'
import InputText from 'primevue/inputtext'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import { Form, Field, FieldArray } from 'vee-validate'
import * as Yup from 'yup'
import {
  getCurrentInstance,
  onMounted,
  reactive,
  ref,
  toRefs
} from 'vue'
import apiUseCase from '@/usecase/apiUseCase'
import { useStore } from 'vuex'
import { isNull } from 'lodash'
import rgxExp from '@/utils/helpers/regExp'
import moment from 'moment'
import HjpConfirmationModal from '@/views/components/modal/HjpConfirmationModal.vue'

export default {
  components: {
    Dialog,
    Form,
    Field,
    // FieldArray,
    InputNumber,
    InputText,
    Button,
    HjpConfirmationModal
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    ritId: {
      type: String,
      default: ''
    },
    trayekId: {
      type: String,
      default: ''
    },
    dataHeader: {
      default: {}
    }
  },
  emits: ['hideDialogCloseRit', 'reloadData'],
  setup(props: any, { emit }: any) {
    const trayekEndpoint = '/management/v1/Trayek'
    const otherRevenueEndpoint = '/management/v1/MsOtherRevenue'
    const ritEndpoint = '/transaction/v1/Rit'

    const app = getCurrentInstance()
    const {
      $toast
    } = app!.appContext.config.globalProperties
    const store = useStore()
    const isLoading = ref(false)
    const { show, trayekId, ritId, dataHeader } = toRefs(props)
    const showModal = show.value
    const dataSource = ref([]) as any
    const dataSourceTemp = ref([]) as any
    // const TrxId = trxId.value
    const dataForm = ref()

    const otherRevenues = ref([]) as any

    const ritExpenses = ref([]) as any

    const dataDummy = ref({
      kondektur: '',
      helper: '',
      driver: '',

    })

    const initialValue = reactive({
      condecturName: dataHeader.value.condectur,
      driverName: dataHeader.value.driver,
      helperName: dataHeader.value.helper,
    })

    const schema = Yup.object().shape({
      condecturName: Yup.string()
        .matches(rgxExp.notPrefixSpace, 'Nama Kondektur tidak boleh hanya menggunakan spasi')
        .required('Nama Kondektur tidak boleh kosong')
        .max(50, 'Nama Kondektur tidak boleh melebihi 100 karakter'),
      driverName: Yup.string()
        .matches(rgxExp.notPrefixSpace, 'Nama Sopir tidak boleh hanya menggunakan spasi')
        .required('Nama Sopir tidak boleh kosong')
        .max(50, 'Nama Sopir tidak boleh melebihi 100 karakter'),
      helperName: Yup.string()
        .matches(rgxExp.notPrefixSpace, 'Nama Pembantu tidak boleh hanya menggunakan spasi')
        .required('Nama Pembantu tidak boleh kosong')
        .max(50, 'Nama Pembantu tidak boleh melebihi 100 karakter'),
    })

    const attrModalConfirmation = reactive({
      show: false,
      title: 'Akhiri RIT?',
      subTitle: 'Sebelum mengakhiri RIT, pastikan perjalanan bus tersebut sudah selesai!',
      btnSubmitTitle: 'Akhiri RIT',
      imgContent: require('@/assets/img/modal-confirmation/close-rit.svg')
    })

    const closeDialog = () => {
      emit('hideDialogCloseRit')
    }

    const reloadHeaderAct = () => {
      emit('reloadData')
    }

    const getRitExpenses = async () => {
      store.dispatch('showLoading')
      await apiUseCase.get(`${trayekEndpoint}/${'b246bfdf-b1a8-4400-50e6-08dc4ed3aa71'}/MsRoute/${'4ad475aa-2b43-45dc-f128-08dc4d6928b5'}/MsExpense`).then((response) => {
        const {
          error,
          result
        } = response
        if (!error) {
          // eslint-disable-next-line no-unused-expressions, array-callback-return
          result?.MsExpensesDetails.map((data: any) => {
            const obj = {
              Id: data.MsExpensesType?.Id,
              Name: data.MsExpensesType?.Name,
              Value: data.Nominal
            }
            ritExpenses.value.push(obj)
          })
          console.log('ritExpenses', ritExpenses)
        }
      })
      store.dispatch('hideLoading')
    }

    const onSubmit = (values: any) => {
      dataForm.value = {
        Id: ritId.value,
        StartDate: dataHeader.value.CreatedAt,
        EndDate: moment(),
        DriverId: null,
        DriverName: values.driverName,
        HelperId: null,
        HelperName: values.helperName,
        CounterPrintTicket: 0,
        RitExpenses: [],
        RitOtherRevenues: []
      }

      // eslint-disable-next-line array-callback-return
      ritExpenses.value.map((data: any) => {
        const obj = {
          IssuedBy: dataHeader.value.condecturId,
          ExpenseId: data.Id,
          Nominal: data.Value,
          ExpenseName: data.Name
        }
        dataForm.value.RitExpenses.push(obj)
      })

      // eslint-disable-next-line array-callback-return
      otherRevenues.value.map((data: any) => {
        const obj = {
          MsRevenueId: data.Id,
          RevenueName: data.Name,
          Quantity: data.Total,
          Value: data.Nominal
        }
        dataForm.value.RitOtherRevenues.push(obj)
      })
      attrModalConfirmation.show = true
      console.log('dataForm', dataForm.value)
    }

    const progressCloseRit = async () => {
      store.dispatch('showLoading')
      await apiUseCase.putWithNoId(`${ritEndpoint}/closed`, dataForm.value).then((response) => {
        const { error } = response
        if (!error) {
          $toast.add({
            severity: 'success',
            detail: 'Rit berhasil ditutup',
            group: 'bc',
            closable: false,
            life: 3000
          })
          reloadHeaderAct()
          closeDialog()
        } else {
          $toast.add({
            severity: 'error',
            detail: response.message,
            group: 'bc',
            closable: false,
            life: 3000
          })
        }
      })
      // eslint-disable-next-line no-use-before-define
      hideConfirmCloseRitDialog()
      store.dispatch('hideLoading')
    }

    const hideConfirmCloseRitDialog = () => {
      attrModalConfirmation.show = false
    }

    const getOtherRevenues = async () => {
      await apiUseCase.get(`${otherRevenueEndpoint}?isActive=true`).then((response) => {
        const {
          error,
          result
        } = response

        if (!error) {
          otherRevenues.value = result.map((data: any) => ({
            ...data,
            Total: 0,
            Nominal: 0
          }))

          console.log('otherRevenues', otherRevenues.value)
        }
      })
    }

    onMounted(() => {
      // getDetail()
      // dataForm.value = dataHeader.value
      getRitExpenses()
      getOtherRevenues()
    })

    return {
      isLoading,
      showModal,
      closeDialog,
      dataSource,
      onSubmit,
      dataDummy,
      otherRevenues,
      ritExpenses,
      dataHeader,
      dataForm,
      initialValue,
      schema,
      attrModalConfirmation,
      hideConfirmCloseRitDialog,
      progressCloseRit
      // TrxId
    }
  }
}
